package com.checkin.shared.legal

data class LegalSection(
    val title: String,
    val paragraphs: List<String>,
)

data class LegalDocument(
    val title: String,
    val updatedAt: String,
    val version: String = LegalVersion.CURRENT,
    val sections: List<LegalSection>,
)
